import { Box, Text, VStack } from '@chakra-ui/react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { HiOutlineInformationCircle } from 'react-icons/hi2';

// Rendered when the bot marks a message with '{%EndConversation}' (entity
// configured with "Zakończ konwersację" / EndConversation=true). Visual spec
// is a placeholder until the final Figma design for this state is delivered.
const EndConversationNotice = ({ message, colors }) => {
    const { t } = useTranslation('chat');

    const messageContent = useMemo(() => {
        const raw = typeof message.text === 'string' ? message.text : '';
        const stripped = raw.replace('{%EndConversation}', '').trim();
        return stripped || t('endConversation.defaultMessage');
    }, [message.text, t]);

    return (
        <Box display="flex" justifyContent="center" px={6} py={3}>
            <VStack
                gap={2}
                maxW="320px"
                bg={colors.chatBg}
                border="1px solid"
                borderColor={colors.borderColor}
                borderRadius="16px"
                px={5}
                py={4}
                textAlign="center"
            >
                <HiOutlineInformationCircle size={24} color={colors.avatarBg} />
                <Text fontSize="sm" color={colors.textSecondary} lineHeight="1.5">
                    {messageContent}
                </Text>
            </VStack>
        </Box>
    );
};

export default EndConversationNotice;
